import type { ReactNode } from 'react';

import { Spinner } from '../../dashboards/primitives';
import { EmptyState } from '../../dashboards/primitives/EmptyState';

import { ListLoadFailure, type ListLoadFailureKind } from './ListLoadFailure';

import './list-page.css';

export interface ListPageResultsProps {
  /** Plural and lower case: "campaigns", "bundles". */
  noun: string;
  loading: boolean;
  failure: ListLoadFailureKind | null;
  onRetry: () => void;
  empty: { title: string; hint?: string } | null;
  table: ReactNode;
  cards: ReactNode;
}

export function ListPageResults({
  noun,
  loading,
  failure,
  onRetry,
  empty,
  table,
  cards,
}: ListPageResultsProps) {
  if (failure) return <ListLoadFailure noun={noun} failure={failure} onRetry={onRetry} />;
  if (loading) {
    return (
      <div role="status" style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
        <Spinner size={22} />
        <span className="nb-sr-only">Loading {noun}</span>
      </div>
    );
  }
  if (empty) return <EmptyState title={empty.title} hint={empty.hint} />;
  return (
    <>
      <div className="nb-listpage-table-view">{table}</div>
      <div className="nb-listpage-cards">{cards}</div>
    </>
  );
}
